module.exports = __webpack_public_path__ + "static/media/20_B.d89bbc4d.png";